import {
  ConnectedPosition,
  Overlay,
  OverlayContainer,
  OverlayPositionBuilder,
  OverlayRef,
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, ElementRef, inject, input, OnDestroy } from '@angular/core';

import { TooltipComponent } from '../components/tooltip/tooltip.component';

@Directive({
  host: {
    '(mouseenter)': 'show()',
    '(mouseleave)': 'hide()',
  },
  selector: '[auxTooltipOverflow]',
  standalone: true,
})
export class TooltipOverflowDirective implements OnDestroy {
  elementRef = inject(ElementRef);
  overlay = inject(Overlay);
  overlayContainer = inject(OverlayContainer);
  overlayPositionBuilder = inject(OverlayPositionBuilder);

  panelContainerClass = input<string | undefined>(undefined);
  positions = input<ConnectedPosition[]>([
    {
      offsetY: -8,
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'bottom',
    },
    {
      offsetY: 8,
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
    },
  ]);
  text = input('', {
    alias: 'auxTooltipOverflow',
  });

  overlayRef?: OverlayRef;

  ngOnDestroy(): void {
    this.destroyOverlay();
  }

  destroyOverlay = () => {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
    this.overlayRef = undefined!;
  };

  // Hide tooltip on mouseleave
  hide = () => {
    this.destroyOverlay();
  };

  // Check if the element is overflowing
  isOverflowing = (): boolean => {
    const el = this.elementRef.nativeElement as HTMLElement;

    return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
  };

  // Show tooltip only if overflowing
  show = () => {
    if (!this.text()) return;

    if (!this.isOverflowing()) return;
    this.destroyOverlay();
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions(this.positions());
    const overlayRef = this.overlay.create({ positionStrategy });
    const tooltipRef = overlayRef.attach(new ComponentPortal(TooltipComponent));

    tooltipRef.instance.text = this.text();
    this.overlayRef = overlayRef;
  };
}
